__turbopack_context__.v({
  "column": "_41FWma_column",
  "grid": "_41FWma_grid",
  "image": "_41FWma_image",
  "image__wrapper": "_41FWma_image__wrapper",
  "row": "_41FWma_row",
  "shimmer": "_41FWma_shimmer",
  "text": "_41FWma_text",
  "text-bar-sweep": "_41FWma_text-bar-sweep",
});
